import React, { useEffect } from "react";

const Instagram = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      const instagramLinks = document.querySelectorAll(
        "#eapps-instagram-feed-1 a"
      );

      if (instagramLinks.length > 0) {
        instagramLinks.forEach((link) => {
          link.style.display = "none";
        });
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="instagram-feed">
      <script
        src="https://static.elfsight.com/platform/platform.js"
        async
      ></script>
      <div
        className="elfsight-app-ff5bd3f1-fe05-4060-8f7a-002b16ba8971"
        data-elfsight-app-lazy
      ></div>
      {/* <iframe
        src="https://app.mirror-app.com/feed-instagram/f32010d9-ca8f-4117-bec9-1357ed39338e/preview"
        title="instagram-feed-iframe"
        style={{ width: "100%", height: "600px", border: "none" }}
      ></iframe> */}
    </div>
  );
};

export default Instagram;
